// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"294":"0af98a8b","987":"684927a9"}[chunkId] + "." + {"294":"53479189823bcbe0","987":"5bce7ffc50318508"}[chunkId] + ".js";
};